import * as Yup from 'yup';
import getFormErrors from '../utils/translations/formErrors.translations';
import { applyThousandsSeparator } from '../utils/misc/applyThousandsSeparator';
Yup.setLocale({
    mixed: {
        required: function (meta) {
            return getFormErrors(meta.label).required;
        },
        defined: function (meta) {
            return getFormErrors(meta.label).required;
        },
        notType: function (meta) {
            if (meta.type === 'date') {
                return getFormErrors(meta.label).invalidDate;
            }
            return "YUP.setLocale: error message for invalid type ".concat(meta.type, " was not described");
        },
    },
    number: {
        min: function (meta) {
            return getFormErrors(meta.label, applyThousandsSeparator(String(meta.min))).minValue;
        },
        max: function (meta) {
            return getFormErrors(meta.label, applyThousandsSeparator(String(meta.max))).maxValue;
        },
    },
    string: {
        min: function (meta) {
            return getFormErrors(meta.label, meta.min).minLength;
        },
        max: function (meta) {
            return getFormErrors(meta.label, meta.max).maxLength;
        },
        email: function (meta) {
            return getFormErrors(meta.label).email;
        },
    },
    date: {
        required: function (meta) {
            return getFormErrors(meta.label).requiredDate;
        },
    },
});
export var Schema = Yup;
